import type { UserProfileEvent } from "@/services/api/management";
import type { AdminPurchase } from "@/services/api/management";

const RANK: Record<string, number> = { free: 0, standard: 1, premium: 2 };

/**
 * JUB-157: events a purchase can be moved or applied to — the same owner
 * (the profile lists only this user's events), not in the Trash, on a lower
 * plan, and not the event that already holds it. The API enforces the rest
 * (contributions, RSVPs).
 */
export function eligibleTargets(purchase: AdminPurchase, events: UserProfileEvent[]): UserProfileEvent[] {
  return events.filter(
    (event) =>
      !event.trashed &&
      event.event_uuid !== purchase.eventUuid &&
      (RANK[event.plan] ?? 0) < (RANK[purchase.plan] ?? 0)
  );
}
